export const SNAPSHOT_SELECTOR_SELECTION = {
  ENTER_NEW_DATA: 1,
  ENTER_HISTORICAL_DATA: 2,
  MODIFY_CURRENT_DATA: 3,
  MODIFY_HISTORICAL_DATA: 4,
  ENTER_SHOP_DATA: 5,
};
